import {
  Box,
  Stack,
  Typography,
  Button,
  ToggleButtonGroup,
  ToggleButton,
  toggleButtonGroupClasses,
  toggleButtonClasses
} from "@mui/material";
import {styled} from "@mui/system";
import Backdrop from "@mui/material/Backdrop";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import RpIcon from "@/components/RpIcon";
import AppModal from "@/components/AppModal";
import AppDatePicker from "@/components/AppDatePicker";
// import PageBack from "@/components/PageBack";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import dayjs from "dayjs";
import {enqueueSnackbar} from "notistack";

interface Props {
  open: boolean;
  onClose: () => void;
  onSearch: (select: { daysLasting: string, startTime: string, endTime: string }) => void;
}

const filterList = [
  {id: "all", local: "all"},
  {id: "1", local: "today"},
  {id: "2", local: "last_7_days"},
  {id: "3", local: "last_30_days"},
  {id: "customize", local: "customize"}
];

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({theme}) => {
  return {
    // border: '1px solid red',
    [`& .${toggleButtonGroupClasses.grouped}`]: {
      borderWidth: 0,
      backgroundColor: theme.palette.background.default,
      padding: '12px 16px !important',
      '&:hover': {
        backgroundColor: theme.palette.background.default,
      }
    },
    [`& .${toggleButtonClasses.selected}`]: {
      border: '1px solid white',
    }
  }
})

export default function SearchItem({open, onClose, onSearch, searchItems}: any) {
  const {t} = useTranslation("translation");

  const [optionId, setOptionId] = useState('all');

  const [currentSelect, setCurrentSelect] = useState({
    daysLasting: filterList[0].id,
    startTime: '',
    endTime: ''
  });

  useEffect(() => {
    setCurrentSelect({
      daysLasting: searchItems?.daysLasting,
      startTime: searchItems?.startTime,
      endTime: searchItems?.endTime
    })
  }, [searchItems]);

  const handleSearch = async () => {
    const isDateVerify= verifyDate()
    if(isDateVerify){
      onSearch(currentSelect);
    }
  }
  const verifyDate= ()=>{
    if(currentSelect.daysLasting=="customize"){//自定义时间做校验
      if(!currentSelect.startTime || !currentSelect.endTime){
        enqueueSnackbar(t('custom_date_null'), { variant: 'error',autoHideDuration:1500 })
        return false
      }else{
        const start = dayjs(currentSelect.startTime)
        const end = dayjs(currentSelect.endTime)
        const isSameDay = start.isSame(end, 'day'); 
        const isBefore = start.isBefore(end)
        if(!isSameDay && !isBefore){
          enqueueSnackbar(t('custom_date_error'), { variant: 'error',autoHideDuration:1500 })
          return false
        }
      }
    }
    return true
  }

  const handleChange = (value) => {
    setCurrentSelect((prevSelect) => ({
      ...prevSelect,
      daysLasting: value,
    }));
  };

  function setFieldValue(field: string, value: string) {
    setCurrentSelect((prevTime) => ({
      ...prevTime,
      [field]: value,
    }));
  }

  const handleReset = () => {
    setCurrentSelect({
      daysLasting: 'all',
      startTime: '',
      endTime: ''
    });
    setOptionId('all')
  };

  const onChange = (e, newValue) => {
    setOptionId(newValue);
    setCurrentSelect((prevSelect) => ({
      ...prevSelect,
      daysLasting: newValue,
    }));
  }

  return (
    <AppModal
      title={'Date'}
      open={open}
      onClose={() => {
        onClose()
      }
      }
      closeAfterTransition
      slots={{backdrop: Backdrop}}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Stack>
        <SimpleHeader
        title={t('date')}
        action={<Button onClick={handleReset}>{t('reset')}</Button>}
        onBackClick={() => {
          onClose && onClose()
        }}
        />
      </Stack>
      <Box sx={{padding: '16px'}}>
        <Typography sx={{paddingTop:'14px',fontSize:'16px'}}>{t("date")}</Typography>
        <Stack className="" direction="row" gap={'12px'} flexWrap="wrap" sx={{
          paddingTop: '10px'
        }}>
          <StyledToggleButtonGroup
            exclusive
            aria-label="text alignment"
            value={optionId}
            onChange={onChange}
            sx={{display: 'flex', flexWrap: 'wrap', gap: '16px'}}
          >
            {
              filterList.map(item => {
                return (
                  <ToggleButton sx={{width: 'auto'}}
                                key={item.id}
                                value={item.id} aria-label="left aligned">
                    <Typography sx={theme => ({fontSize: theme.typography.pxToRem(14)})}>
                      {t(item.local)}
                    </Typography>
                  </ToggleButton>
                )
              })
            }
          </StyledToggleButtonGroup>
        </Stack>
        {currentSelect.daysLasting === "customize" && (<>
        {/*<Typography sx={{*/}
        {/*  paddingTop: '20px'*/}
        {/*}}>{t('customize')}</Typography>*/}

          <Stack direction="row" sx={{
            paddingTop: '14px',
            alignItems: 'center',
            gap: '12px'
          }}>
            <AppDatePicker
              name="startTime"
              size="small"
              variant="outlined"
              onChange={(date) => setFieldValue("startTime", date)}
              onBlur={(date) => setFieldValue("startTime", date)}
              add
              value={currentSelect.startTime}
              input
              slots={{
                openPickerIcon: () => <RpIcon icon="calendar" size={16}/>,
              }}
            />
            <span className="px-2">{t("to")}</span>

            <AppDatePicker
              name="endTime"
              size="small"
              variant="outlined"
              onChange={(date) => setFieldValue("endTime", date)}
              onBlur={(date) => setFieldValue("endTime", date)}
              add
              value={currentSelect.endTime}
              input
              slots={{
                openPickerIcon: () => <RpIcon icon="calendar" size={16}/>,
              }}
              renderI
            />
          </Stack>
          </>
        )}

        <Stack gap={'12px'} direction="column" sx={{marginTop: '14px'}}>
          <Button sx={{borderRadius:"20px"}} fullWidth variant="contained" onClick={handleSearch}>{t("search")}</Button>
        </Stack>
      </Box>
    </AppModal>
  );
}
